var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10.8333 9.89917C10.8334 10.0404 10.7976 10.1794 10.7292 10.303C10.6609 10.4266 10.5622 10.5308 10.4425 10.6058L7.2425 12.6058C7.14949 12.6639 7.04593 12.7032 6.93775 12.7213C6.82958 12.7393 6.7189 12.7359 6.61203 12.7113C6.50517 12.6866 6.40421 12.6411 6.31493 12.5774C6.22564 12.5137 6.14978 12.433 6.09167 12.34C6.03356 12.247 5.99434 12.1434 5.97625 12.0352C5.95816 11.9271 5.96156 11.8164 5.98624 11.7095C6.01093 11.6027 6.05642 11.5017 6.12012 11.4124C6.18382 11.3231 6.26448 11.2473 6.3575 11.1892L9.16667 9.4375V5.83333C9.16667 5.61232 9.25447 5.40036 9.41075 5.24408C9.56703 5.0878 9.77899 5 10 5C10.221 5 10.433 5.0878 10.5893 5.24408C10.7455 5.40036 10.8333 5.61232 10.8333 5.83333V9.89917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.50490ef4ddf534e8f0a7806d267c9441.svg";
export { ForwardRef as ReactComponent };